import * as z from "zod";

import { DataFilter } from "interfaces";

const commonSchema = z.object({
  column: z.string(),
  condition: z.enum(["include", "exclude"]),
});

const betweenSchema = z.object({
  operator: z.enum(["between", "in", "not in"]),
});

const threshSchema = z.object({
  operator: z.enum(["lt", "le", "gt", "ge", "eq", "ne"]),
});

const numSchema = commonSchema.extend({
  operator: z.enum([
    "between",
    "in",
    "not in",
    "lt",
    "le",
    "gt",
    "ge",
    "eq",
    "ne",
  ]),
  range: z.number().array().min(1),
});

const dateSchema = commonSchema.extend({
  operator: z.enum([
    "between",
    "in",
    "not in",
    "lt",
    "le",
    "gt",
    "ge",
    "eq",
    "ne",
  ]),
  range: z.date().array().min(1),
});

const numSchemaBetween = commonSchema.merge(betweenSchema).extend({
  range: z.number().array().length(2),
});

const numSchemaThresh = commonSchema.merge(threshSchema).extend({
  range: z.number().array().length(1),
});

const dateSchemaBetween = commonSchema.merge(betweenSchema).extend({
  range: z.date().array().length(2),
});

const dateSchemaThresh = commonSchema.merge(threshSchema).extend({
  range: z.date().array().length(1),
});

const charSchema = commonSchema.extend({
  operator: z.enum([
    "in",
    "not in",
    "sw",
    "nsw",
    "ew",
    "new",
    "eq",
    "ne",
    "cn",
    "ncn",
  ]),
  range: z.string().array().min(1),
});

const validateFilter = (
  f: Partial<DataFilter.Filter>,
  colType: DataFilter.ColumnType
) => {
  if (colType === "char") {
    return charSchema.safeParse(f);
  }
  let nf = { ...f };
  nf.range = ["int", "float", "numeric"].includes(colType)
    ? (nf.range || []).map(parseFloat)
    : ((nf.range || [])
        .map((x) => (x ? new Date(x) : undefined))
        .filter((x) => x) as Date[]);
  if (["int", "float", "numeric"].includes(colType)) {
    const r1 = numSchema.safeParse(nf);
    if (!r1.success) {
      return r1;
    }
    const s = ["between", "in", "not in"].includes(nf.operator || "")
      ? numSchemaBetween
      : numSchemaThresh;
    return s.safeParse(nf);
  } else {
    const rd = dateSchema.safeParse(nf);
    if (!rd.success) {
      return rd;
    }
    const s = ["between", "in", "not in"].includes(nf.operator || "")
      ? dateSchemaBetween
      : dateSchemaThresh;
    return s.safeParse(nf);
  }
};

export default validateFilter;
